import React, { useEffect, useState } from "react";
import './Login.css'
import { useForm } from "antd/es/form/Form";
import { FaUser, FaLock } from "react-icons/fa";
import {Form, Input } from "antd";
import MobileWithMan from '../../Assets/JeevanMobSit.png.svg';
import LoginLogo from '../../Assets/TailingStyleCenter.png'
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import 'react-toastify/dist/ReactToastify.css';


function Login() {
    const Navigate = useNavigate()
    const [LoginForm] = useForm()
    const [LoaderHiden, setLoaderHiden] = useState(false)
    useEffect(()=>{
        Navigate("/")
    },[])

    const checkUserName = () => {
        let Input = LoginForm.getFieldValue()
        if (Input.UserName) {
            setLoaderHiden(true)
            let URL = process.env.REACT_APP_PERMIT + "/User/CheckUser?EmpID=" + Input.UserName
            axios.get(URL)
                .then((Res) => {
                    if (Res.data === false) {
                        setLoaderHiden(false);
                        toast.warning("Invalid User...", {
                            position: "top-center",
                            autoClose: 2000,
                        });
                        LoginForm.setFieldsValue({ UserName: '' });
                    } else {
                        setLoaderHiden(false);
                    }
                })
                .catch(error => {
                    console.error("Error occurred:", error);
                });
        }
    }

    const onLoginClick1 = () => {
        let Input = LoginForm.getFieldValue()
        if (Input) {
            setLoaderHiden(true)
            Input = { empID: Input.UserName.toUpperCase(), password: Input.Password };
            let URL = process.env.REACT_APP_PERMIT + "/User/UserLogin"
            axios.post(URL, Input)
                .then((Res) => {
                    
                    if (Res.data.status === true) {
                        // console.log(Res.data,"UserData")
                        setLoaderHiden(false)
                        let SessionValue = {}
                        SessionValue.employeeId = Res.data.employeeId;
                        SessionValue.employeeName = Res.data.employeeName;
                        SessionValue.divisionID = Res.data.divisionID;
                        SessionValue.divisionName = Res.data.divisionName;
                        SessionValue.photo = Res.data.photo;
                        SessionValue.status = Res.data.status;
                        SessionValue.isApprover = Res.data.isApprover;
                        SessionValue.isExtensionApprover = Res.data.isExtensionApprover
                        SessionValue.designation = Res.data.designation;
                        SessionValue.isCreator = Res.data.isCreator;
                        sessionStorage.setItem("UserInfo", JSON.stringify(SessionValue));
                        window.location.reload();
                    } else {
                        setLoaderHiden(false)
                        LoginForm.setFieldsValue({ UserName: '' , Password : ''});
                        toast.warning("Login credentials mismatch !",{
                            position: "top-center",
                            autoClose: 2000,
                        });
                    }
                }) .catch(error => {
                    console.error("Error occurred:", error);
                });
        }
    }

    // const onLoginClick = () => {
    //     let Input = LoginForm.getFieldValue()
    //     if (Input.UserName.substring(0, 3).toUpperCase() === "NPI") {
    //         Input = { EmployeeId: Input.UserName.toUpperCase(), Password: Input.Password };
    //         setLoaderHiden(true)
    //         let URL = process.env.REACT_APP_Login + "/Employee/Authenticate"
    //         axios
    //             .post(URL, Input)
    //             .then(
    //                 (res) => {
    //                     setLoaderHiden(false);
    //                     if (res.data.Status === "No Results Found") {
    //                         toast.warning("Login credentials mismatch !");
    //                         LoginForm.resetFields()
    //                     } else {
    //                         GetMyPermitApprovals(res.data.EmployeeId, res.data)
    //                     }
    //                 },
    //                 (err) => {
    //                     setLoaderHiden(false);
    //                     toast.info({
    //                         message: `Login credentials mismatch`,
    //                         top: 50,
    //                     });
    //                 }
    //             );
    //     } else {
    //         alert("Others");
    //     }
    // }

    const GetMyPermitApprovals = (LoginID, SessionValue) => {
        setLoaderHiden(true)
        let URL = process.env.REACT_APP_PERMIT + "/User/CheckUser?EmpID=" + LoginID + "&Devsion=" + SessionValue.BusinessUnit
        axios.get(URL).then((Res) => {
            setLoaderHiden(false);
            SessionValue.divisionID = Res.data.divisionID;
            SessionValue.Approver = Res.data.approver;
            SessionValue.Designation = Res.data.designation;
            SessionValue.appproverLevel = Res.data.appproverLevel
            sessionStorage.setItem("UserInfo", JSON.stringify(SessionValue));
            window.location.reload();

        }).catch((Error) => {
            setLoaderHiden(false);
            console.log(Error, "Error GetMyPermitApprovals")
        })
    }
    return (
        <div className="LoginMainClass">
            {LoaderHiden && <Loader />}
            <div className="container">
                <div className="img">
                    <img src={MobileWithMan} alt="" />
                </div>
                <div className="login-container">
                    <div>
                        <Form form={LoginForm} onFinish={() => onLoginClick1()}>
                            <img className="avatar" src={LoginLogo} alt="" />
                            <Form.Item name={"UserName"} rules={[
                                {
                                    required: true,
                                    message: 'Please input your Username!',
                                }
                            ]}>
                                <Input placeholder="User Name" size="large" prefix={<FaUser />}
                                onBlur={()=> checkUserName()} 
                                />
                            </Form.Item>
                            <Form.Item name={"Password"} rules={[
                                {
                                    required: true,
                                    message: 'Please input your Password!',
                                }
                            ]}>
                                <Input placeholder="Password" type="password" size="large" prefix={<FaLock />} />
                            </Form.Item>
                            <Form.Item className="LoginButton_Align">
                                <Input className="btn" type="submit" value="Login" />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
export default Login;

